<template>
  <div>
    <div class="body-overlay"></div>
    <div id="wrapper" class="clearfix">
      <div class="main-content">
        <section>
          <div class="header-bg" v-bind:style="{ background: 'url(' + cover_image + ')' }">
            <div class="cover-bg-color"></div>
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <div class="h-inner">
                    <div class="logo-absolute">
                      <div class="logo-box">
                        <div class="org_logo">
                          <img id="logo-img" v-bind:src="logo"/>
                        </div>
                      </div>
                      <div class="com-details">
                        <div class="com-names">
                          <span v-html="name"></span>
                          <div v-if="labelsData.Verified" class="tooltip-main labelImg display-inline-block w-70">
                            <img src="/images/all-jobs/verified.png"/>
                            <span class="tooltiptext tooltip-bottom left-25">Verified</span>
                          </div>
                        </div>
                        <div class="com-establish">
                          {{ tag_line }}
                        </div>
                        <div class="com-establish">
                          {{ industry }}
                        </div>
                        <div class="com-establish" v-if="labelsData">
                          <div v-if="labelsData.Featured" class="tooltip-main">
                            <img src="/images/all-jobs/featured.png">
                            <span class="tooltiptext tooltip-bottom">Featured</span>
                          </div>
                          <div v-if="labelsData.Hot" class="tooltip-main">
                            <img src="/images/all-jobs/hot.png">
                            <span class="tooltiptext tooltip-bottom">Hot</span>
                          </div>
                          <div v-if="labelsData.Promoted" class="tooltip-main">
                            <img src="/images/all-jobs/promoted.png">
                            <span class="tooltiptext tooltip-bottom">Promoted</span>
                          </div>
                          <div v-if="labelsData.Trending" class="tooltip-main">
                            <img src="/images/all-jobs/trending.png">
                            <span class="tooltiptext tooltip-bottom">Trending</span>
                          </div>
                          <div class="newJobIcon tooltip-main" v-if="labelsData.New">
                            <img src="/images/all-jobs/new-job.png">
                            <span class="tooltiptext tooltip-bottom">Featured</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="container padd-top-0">
            <div class="row">
              <div class="col-md-6 col-md-offset-2 col-sm-10 col-sm-offset-2 col-xs-12">
                <ul class="nav nav-tabs nav-padd-20" v-if="this.$store.getters.getUserType">
                  <li class="active"><a data-toggle="tab" href="#home">Overview</a></li>
                  <li><a data-toggle="tab" href="#menu1"
                         v-if="opportuntiesJobs.length || opportuntiesInternships.length">Opportunities</a>
                  </li>
                  <li v-if="this.$store.getters.getUserType != 'Individual' && appliedCandidates.length">
                    <a data-toggle="tab" href="#menu2">Applied Candidates
                      ({{ appliedCandidatesCount }})</a></li>
                </ul>
              </div>
              <div class="col-md-4 col-sm-12 col-xs-12">
                <div class="follow-btn" v-if="this.$store.getters.getUserType == 'Individual'">
                  <button class="follow" @click.prevent="follow($event)" v-if="!followed"
                          v-bind:data-key="organization_enc_id">Follow
                  </button>
                  <button class="follow" @click.prevent="follow($event)" v-if="followed"
                          v-bind:data-key="organization_enc_id">Following
                  </button>
                </div>
                <div class="social-btns">
                  <a v-bind:href="facebook" class="facebook" target="_blank" v-if="facebook"><i
                      class="fab fa-facebook-f"></i> </a>
                  <a v-bind:href="twitter" class="twitter" target="_blank" v-if="twitter"><i
                      class="fab fa-twitter"></i> </a>
                  <a v-bind:href="linkedin" class="linkedin" target="_blank" v-if="linkedin"><i
                      class="fab fa-linkedin-in"></i> </a>
                  <a v-bind:href="website" class="web" target="_blank" v-if="website"><i
                      class="fas fa-link"></i> </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="container">
            <div class="tab-content">
              <div id="home" class="tab-pane fade in active">
                <div class="row">
                  <div class="heading-style" v-html="'About '+name">

                  </div>
                  <div class="divider"></div>

                  <div class="col-md-7 col-xs-12">
                    <div class="com-description">
                      {{ description }}
                    </div>
                  </div>
                  <div class="col-md-5 col-xs-12">
                    <div class="a-boxs">
                      <div class="row margin-0">
                        <div class="col-md-4 col-sm-4 col-xs-12 about-box">
                          <div class="">
                            <div class="about-det">
                              <div class="det">
                                {{ number_of_employees ? number_of_employees : "NA" }}
                              </div>
                              <div class="det-heading">Employees</div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4 col-sm-4 col-xs-12 about-box">
                          <div class="">
                            <div class="about-det">
                              <div class="det">{{ opportunties_count ? opportunties_count : "NA" }}</div>
                              <div class="det-heading">Opportunities</div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4 col-sm-4 col-xs-12 about-box">
                          <div class="">
                            <div class="about-det">
                              <div class="det">
                                {{ establishment_year ? establishment_year : "NA" }}
                              </div>
                              <div class="det-heading">Established</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 col-sm-4" v-if="reviews_cnt != 0">
                      <div class="sub-review-box">
                        <div class="rating-large">{{ average_rating }}/5</div>
                        <div class="rs-main">
                          <div class="com-rating-1">
                            <i class="fas fa-star active" v-for="li in average_rating"
                               v-if="average_rating != 0"></i>
                            <i class="fas fa-star" v-for="li in 5 - average_rating"
                               v-if="average_rating != 5"></i>
                          </div>
                          <div class="reviewers">{{ reviews_cnt }} Reviews</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="mission || vision">
                  <div class="mv-box">
                    <div class="heading-style">Mission & Vision</div>
                    <div class="divider"></div>
                    <div class="col-md-12" v-if="vision">
                      <div class="mv-heading">
                        Vision
                      </div>
                      <div class="mv-text">
                        {{ vision }}
                      </div>
                    </div>
                    <div class="col-md-12" v-if="mission">
                      <div class="vission-box">
                        <div class="mv-heading">
                          Mission
                        </div>
                        <div class="mv-text">
                          {{ mission }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="company-benefits" v-if="benefit.length">
                    <div class="heading-style">Employee Benefits</div>
                    <div class="divider"></div>
                    <div class="com-benefits no-padd">
                      <div class="col-md-3 col-sm-4 col-xs-12" v-for="b in benefit">
                        <div class="benefit-box">
                          <div class="bb-icon">
                            <img v-bind:src="b.icon"/>
                          </div>
                          <div class="bb-text">
                            {{ b.benefit }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="office-view" v-if="gallery.length">
                    <div class="heading-style" v-html="'Inside '+name"></div>
                    <div class="divider"></div>
                    <div class="office-pics">
                      <div class="col-md-3 col-sm-3 col-xs-12 no-padd" v-for="g in gallery">
                        <div class="img1">
                          <a>
                            <img v-bind:src="g.image">
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="company-team" v-if="team.length">
                    <div class="heading-style">Meet The Team</div>
                    <div class="divider"></div>
                    <div class="team-box">
                      <div class="col-md-3 col-sm-6" v-for="t in team">
                        <div class="team-container">
                          <a href="#">
                            <div class="team-icon">
                              <img v-bind:src="t.image"/>
                              <div class="team-overlay"
                                   v-if="t.facebook || t.linkedin || t.twitter">
                                <div class="team-text">
                                  <div class="know-bet">Know me better</div>
                                  <a v-bind:href="t.facebook" target="_blank"
                                     v-if="t.facebook"><i
                                      class="fab fa-facebook-f t-fb"></i></a>
                                  <a v-bind:href="t.linkedin" target="_blank"
                                     v-if="t.linkedin"><i
                                      class="fab fa-linkedin-in t-ln"></i></a>
                                  <a v-bind:href="t.twitter" target="_blank"
                                     v-if="t.twitter"><i
                                      class="fab fa-twitter t-tw"></i></a>
                                </div>
                              </div>
                            </div>
                            <div class="t-member">
                              <div class="t-name">{{ t.first_name }} {{ t.last_name }}
                              </div>
                              <div class="t-post">{{ t.designation }}</div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="menu1" class="tab-pane fade">
                <div class="row" v-if="opportuntiesJobs.length">
                  <div class="heading-style">
                    Available Jobs
                  </div>
                  <div class="divider"></div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="col-md-4 col-sm-12 col-xs-12" v-for="oj in opportuntiesJobs">
                        <div class="job-box">
                          <div class="jb-com-icon">
                            <img v-bind:src="oj.logo" v-bind:alt="oj.name"
                                 v-bind:title="oj.name"/>
                          </div>
                          <div class="jb-com-name">
                            <p v-html="oj.name"></p>
                          </div>
                          <div class="jb-job-title">
                            <span v-html="oj.title"></span>
                            <div v-if="oj.is_exclusive" class="tooltip-main labelImg display-inline-block">
                              <img src="images/all-jobs/exclusive.png" width="30" hspace="5"/>
                              <span class="tooltiptext tooltip-bottom">Exclusive</span>
                            </div>
                          </div>
                          <div class="jb-job-positions">
                            <router-link
                                :to="{path: '/dashboard/application-processes?id=' + oj.slug}"
                                v-if="oj.applied_count != 0">
                              {{ oj.applied_count }} Students Applied
                            </router-link>
                          </div>
                          <span class="stamp is-nope" v-if="oj.is_closed">Recruitment Completed</span>
                          <div class="jb-job-location">
                                                        <span
                                                            v-if="oj.applicationPlacementLocations.length">
                                                        <i class="fas fa-map-marker-alt"></i> {{
                                                            oj.applicationPlacementLocations[0].name
                                                          }}
                                                        </span>
                          </div>
                          <div class="jb-job-positions">
                            <p v-if="oj.positions != ''">{{ oj.positions }} Positions</p>
                          </div>
                          <div class="jb-view-details">
                            <router-link :to="{path: '/detail?id=' + oj.slug}">View Job Detail
                            </router-link>
                            <div v-if="oj.filling_soon && !oj.is_closed"
                                 class="tooltip-main labelImg display-inline-block">
                              <img src="images/all-jobs/filling-soon.png" width="15" hspace="5"/>
                              <span class="tooltiptext tooltip-bottom">Filling Soon</span>
                            </div>
                          </div>
                          <div class="jb-tag dropdown p-0" title="Pending"
                               v-if="userType != 'Individual' && oj.is_college_approved != 1 && !oj.is_closed">
                            <button class="btn dropdown-toggle" type="button"
                                    data-toggle="dropdown">Pending
                              <span class="caret"></span></button>
                            <ul class="dropdown-menu">
                              <li><a href="javascript:;"
                                     @click="changeAppStatus($event, 'Accept')"
                                     :data-key="oj.application_enc_id"
                                     :data-id="oj.organization_enc_id" title="Accept">Accept</a>
                              </li>
                              <li><a href="javascript:;"
                                     @click="changeAppStatus($event,'Reject')"
                                     :data-key="oj.application_enc_id"
                                     :data-id="oj.organization_enc_id" title="Reject">Reject</a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row" v-if="opportuntiesInternships.length">
                  <div class="internships-block">
                    <div class="heading-style">
                      Available Internships
                    </div>
                    <div class="divider"></div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="col-md-4 col-sm-12 col-xs-12"
                             v-for="oj in opportuntiesInternships">
                          <div class="job-box">
                            <div class="jb-com-icon">
                              <img v-bind:src="oj.logo" v-bind:alt="oj.name"
                                   v-bind:title="oj.name"/>
                            </div>
                            <div class="jb-com-name">
                              <p v-html="oj.name"></p>
                            </div>
                            <span class="stamp is-nope" v-if="oj.is_closed">Recruitment Completed</span>
                            <div class="jb-job-title">
                              <span v-html="oj.title"></span>
                              <div v-if="oj.is_exclusive" class="tooltip-main labelImg display-inline-block">
                                <img src="images/all-jobs/exclusive.png" width="30" hspace="5"/>
                                <span class="tooltiptext tooltip-bottom">Exclusive</span>
                              </div>
                            </div>
                            <div class="jb-job-location"
                                 v-if="oj.applicationPlacementLocations.length">
                              <i class="fas fa-map-marker-alt"></i>
                              {{ oj.applicationPlacementLocations[0].name }}
                            </div>
                            <div class="jb-view-details">
                              <router-link :to="{path: '/detail?id=' + oj.slug}">View
                                Internship Detail
                              </router-link>
                              <div v-if="oj.filling_soon && !oj.is_closed"
                                   class="tooltip-main labelImg display-inline-block">
                                <img src="images/all-jobs/filling-soon.png" width="15" hspace="5"/>
                                <span class="tooltiptext tooltip-bottom">Filling Soon</span>
                              </div>
                            </div>
                            <div class="jb-tag dropdown p-0" title="Pending"
                                 v-if="userType != 'Individual' && oj.is_college_approved != 1 && !oj.is_closed">
                              <button class="btn dropdown-toggle" type="button"
                                      data-toggle="dropdown">Pending
                                <span class="caret"></span></button>
                              <ul class="dropdown-menu">
                                <li><a href="javascript:;"
                                       @click="changeAppStatus($event, 'Accept')"
                                       :data-key="oj.application_enc_id"
                                       :data-id="oj.organization_enc_id" title="Accept">Accept</a>
                                </li>
                                <li><a href="javascript:;"
                                       @click="changeAppStatus($event,'Reject')"
                                       :data-key="oj.application_enc_id"
                                       :data-id="oj.organization_enc_id" title="Reject">Reject</a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="menu2" class="tab-pane fade" v-if="appliedCandidates.length">
                <div class="row">
                  <div class="col-lg-4 col-md-4 col-sm-6 p-category-main"
                       v-for="cd in appliedCandidates">
                    <div class="paid-candidate-container">
                      <div class="paid-candidate-box">
                        <div class="paid-candidate-inner--box">
                                                    <span class="paid-candidate-status" :class="cd.status">
                                                      {{ cd.status }}</span>
                          <div class="paid-candidate-box-thumb">
                            <img v-bind:src="cd.image"/>
                          </div>
                          <div class="paid-candidate-box-detail">
                            <h4>
                              <router-link
                                  :to="{path: 'dashboard/viewcandidates?id=' + cd.student_id}">
                                {{ cd.first_name }} {{ cd.last_name }}
                              </router-link>
                            </h4>
                            <span class="desination">
                                {{ cd.title }}
                            </span>
                          </div>
                        </div>
                        <div class="paid-candidate-box-exp">
                          <div class="desination">
                            {{ cd.department }}
                          </div>
                        </div>
                        <div class="desination">
                          Application Type:- <span v-if="cd.type == 'Jobs'">Job</span><span v-else>Internship</span>
                        </div>
                      </div>
                      <router-link
                          :to="{path: 'dashboard/viewcandidates?id=' + cd.student_id}"
                          class="btn btn-paid-candidate bt-1">View Detail
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<style scoped>
.tab-content {
  color: #666666;
  font-size: 14px;
  background-color: #fff;
}

section {
  position: relative;
}
section > .container {
  padding-top: 20px !important;
  padding-bottom: 0px !important;
}

.nav-tabs {
  border: none;
}

.nav-tabs > li {
  text-align: center;
  float: left;
  margin-bottom: -1px;
}

.nav-tabs li.active a {
  border: 0px !important;
}

.nav-tabs > li > a {
  border-radius: 0;
  font-family: 'Open Sans', sans-serif;
  font-size: 12px;
  padding: 12px 20px;
  margin-right: 0;
}

.sub-review-box {
  display: flex;
  flex: 1 auto;
  align-items: center;
  justify-content: center;
  background: #00a0e3;
  border-radius: 6px;
  padding: 10px 20px;
  color: #fff;
  margin-top: 20px;
}

.rating-large {
  font-size: 60px;
}

.rs-main {
  max-width: 200px;
  padding: 10px 13px 15px 14px;
  text-align: center;
  color: #fff;
  border-radius: 6px;
  display: inline-block;
  float: left;
  width: 100%;
  margin-right: 15px;
}

.com-rating-1 {
  margin-top: 15px;
}

.com-rating-1 i {
  font-size: 16px;
  background: #fff;
  color: #ccc;
  padding: 7px 5px;
  border-radius: 5px;
  margin: 0px 2px;
}

.com-rating-1 i.active {
  background: #fff;
  color: #00a0e3;
}

.reviewers {
  text-align: left;
  padding-left: 10px;
}

/*----jobs and internships----*/
.internships-block {
  padding-top: 30px;
}

/*----jobs and internships ends----*/
/*----company benefits----*/
.company-benefits {
  padding: 30px 0 0 0;
}

.benefit-box {
  text-align: center;
  border: 1px solid rgba(221, 216, 216, 0.1);
  padding: 25px 10px;
  margin: 0 0 15px 0;
  box-shadow: 2px 4px 17px rgba(221, 216, 216, 0.3);
  padding-bottom: 0px;
  min-height: 165px;
  position: relative;
}

.bb-icon img {
  width: 75px;
  height: 75px;
}

.bb-text {
  padding-top: 10px;
  text-transform: uppercase;
  font-size: 15px;
  font-weight: bold;
}

/*----company benefits ends----*/
/*----mission & vission----*/
.mv-heading {
  font-size: 20px;
  font-weight: bold;
  text-transform: uppercase;
}

.vission-box {
  padding-top: 20px;
}

.mv-box {
  padding-top: 20px;
}

/*----mission & vission end----*/
/*----team----*/
.company-team {
  padding-top: 20px;
}

.team-container {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  height: 100%;
  position: relative;
  margin: 0 0 20px 0;
}

.t-fb:hover {
  color: #3C5A99
}

.t-ln:hover {
  color: #0077B5;
}

.t-tw:hover {
  color: #1DA1F2;
}

.team-container:hover {
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
  -o-transition: .3s all;
  -ms-transition: .3s all;
  -moz-transition: .3s all;
  -webkit-transition: .3s all;
  transition: .3s all;
}

.know-bet {
  font-size: 14px;
  text-transform: uppercase;
  color: #00a0e3;
}

.team-container:hover .team-overlay {
  height: 100%;
}

.team-text {
  color: #000;
  font-size: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
}

.team-text a {
  padding: 0 5px;
}

.team-icon {
  width: 100%;
  height: 186px;
  overflow: hidden;
  object-fit: cover;
  position: relative;
}

.team-icon img {
  border-radius: 10px 10px 0 0;
  width: 100%;
  height: 100%;
}

.team-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, .9);
  overflow: hidden;
  width: 100%;
  height: 0;
  border-radius: 10px 10px 0 0;
  transition: .5s ease;
}

.t-member {
  padding: 5px 10px 10px 10px;
  text-align: center;
}
.w-70{
    width:70px;
}
.left-25{
    left:25%;
}
.t-name {
  font-size: 16px;
  font-weight: bold;
}

/*----team ends----*/
/*----office view-----*/
.img1 img {
  width: 285px;
  height: 200px;
  object-fit: cover;
}

.office-view {
  padding: 40px 0 0 0;
}

.no-padd {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

/*----office view ends----*/
/*----about us-----*/
.com-description {
  font-size: 15px;
  text-align: justify;
  line-height: 22px;
}

.divider {
  border-top: 1px solid #eee;
  padding: 0 0 20px 0;
}

/*----about us ends----*/
/*----grid box----*/
.a-boxs {
  box-shadow: 2px 5px 24px rgba(221, 216, 216, 0.5);
}

.about-box {
  height: 100px;
  border: 1px solid rgba(238, 238, 238, .5);;
  text-align: center;
  position: relative;
}

.margin-0 {
  margin-left: 0px;
  margin-right: 0px;
}

.about-det {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.det-heading {
  font-size: 13px;
  font-weight: bold;
}

.det {
  font-size: 16px;
  color: #00a0e3;
}

/*----grid box ends*/
/*----follow btn----*/
.follow-btn, .social-btns {
  text-align: center
}

.social-btns {
  margin-top: 15px;
}

.social-btns a {
  margin: 0 5px;
  padding: 8px 0;
  box-shadow: 2px 4px 17px rgba(221, 216, 216, 0.8);
}

a.twitter {
  padding: 8px 6px 8px 10px;
  color: #1DA1F2;
}

.twitter:hover {
  background: #1da1f2;
  color: #fff;
}

a.facebook {
  padding: 8px 9px 8px 12px;
  color: #3C5A99;
}

.facebook:hover {
  background: #3c5a99;
  color: #fff;
}

a.linkedin {
  padding: 8px 9px 8px 11px;
  color: #0077B5;
}

.linkedin:hover {
  background: #0077b5;
  color: #fff;
}

a.web {
  padding: 8px 11px 8px 11px;
  color: #ff7803;
}

.web:hover {
  background: #ff7803;
  color: #fff;
}

.follow {
  padding: 10px 0px;
  width: 167px;
  background: transparent;
  border: none;
  font-size: 16px;
  text-transform: capitalize;
  color: #00a0e3;
  box-shadow: 2px 4px 17px rgba(221, 216, 216, 0.8);
}

.follow:hover {
  background: #00a0e3;
  color: #fff;
}

.follow, .follow:hover, a.facebook, .facebook:hover,
a.twitter, .twitter:hover, a.linkedin, .linkedin:hover, a.web, .web:hover {
  transition: .3s all;
}

/*----follow btn ends----*/
/*----tabs----*/
.nav-tabs > li.active a, .nav-tabs > li.active a:hover, .nav-tabs > li.active a:focus {
  color: #fff;
  background-color: #00a0e3 !important;
  box-shadow: 2px 4px 17px rgba(221, 216, 216, 0.8);
  transition: .2s all;

}

.nav-tabs > li > a:hover {
  box-shadow: 2px 4px 17px rgba(221, 216, 216, 0.8);
  color: #00a0e3;
}

.nav-tabs > li > a {
  border: none;
}

.nav-tabs > li > a:hover {
  border: none;
}

/*----tabs end----*/
.header-bg {
  background-repeat: no-repeat !important;
  background-size: 100% 100% !important;
  min-height: 400px;
}

.h-inner {
  position: relative;
  min-height: 400px;
  display: -webkit-box;
}

.logo-absolute {
  position: absolute;
  bottom: -60px;
  display: inherit;
  width: 100%;
}

.com-details {
  width: auto;
}

.logo-box {
  height: 200px;
  width: 200px;
  padding: 0px;
  background: #fff;
  display: table;
  text-align: center;
  border-radius: 4px;
  box-shadow: 2px 4px 17px rgba(221, 216, 216, 0.3);
  position: relative;
}

.org_logo {
  display: table-cell;
  vertical-align: middle;
}

.org_logo img, .org_logo canvas {
  border-radius: 4px;
  max-height: 200px;
  width: 100%;
}

.com-names {
  font-size: 40px;
  font-family: lobster;
  color: #fff;
  padding: 0 0 0 30px;
  line-height: 1.4;
}

.com-names div .tooltip-bottom {
  bottom: -15px;
}

.com-establish {
  color: #fff;
  padding: 0 0 0 30px;
  font-size: 15px;
  line-height: 1.7;
}

.nav-padd-20 {
  padding-left: 50px;
}

.skill a {
  color: black;
  font-size: 18px;
  font-weight: bold;
}

.paid-candidate-container {
  background: #ffffff;
  border-radius: 6px !important;
  overflow: hidden;
  text-align: center;
  margin-bottom: 30px;
  position: relative;
  transition: .4s;
  border: 1px solid #eaeff5;
}

.paid-candidate-container:hover,
.paid-candidate-container:focus {
  transform: translateY(-5px);
  -webkit-transform: translateY(-5px);
  cursor: pointer;
}

.paid-candidate-box-thumb img {
  height: 100%;
}

.paid-candidate-box {
  text-align: center;
  padding: 20px 10px 15px;
}

.paid-candidate-status {
  position: absolute;
  right: 0px;
  top: 0px;
  background: #00a0e3;
  color: #ffffff;
  padding: 4px 18px;
  border-radius: 0;
  font-weight: 500;
}

.paid-candidate-box-thumb {
  margin-bottom: 30px;
  width: 120px;
  height: 120px;
  margin: 15px auto 25px auto;
  border-radius: 50% !important;
  overflow: hidden;
  box-shadow: 0 0px 14px 0 rgba(0, 0, 0, 0.08);
  -webkit-box-shadow: 0 0px 14px 0 rgba(0, 0, 0, 0.08);
  -moz-box-shadow: 0 0px 14px 0 rgba(0, 0, 0, 0.08);
}

.paid-candidate-box-detail h4 {
  margin-bottom: 4px;
  font-size: 20px;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  display: -webkit-inline-box;
  overflow: hidden;
}

.paid-candidate-box-exp {
  display: flex;
  justify-content: center;
}

.paid-candidate-box-detail .desination,
.paid-candidate-box-exp .desination {
  font-weight: 500;
  font-size: 15px;
  color: #677484;
  height: 27px;
  padding: 5px 20px 0;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
}

a.btn.btn-paid-candidate {
  padding: 10px !important;
  display: inline-block;
  width: 100%;
  font-size: 16px;
  font-weight: 500;
  border-radius: 0;
}

a.btn.btn-paid-candidate:hover,
a.btn.btn-paid-candidate:focus {
  background: #00a0e3;
  color: #ffffff;
  -webkit-transition: all .3s ease-in-out;
  -moz-transition: all .3s ease-in-out;
  -o-transition: all .3s ease-in-out;
  -ms-transition: all .3s ease-in-out;
  transition: all .3s ease-in-out;
}

.bt-1 {
  border-top: 1px solid #eaeff5 !important;
}

.com-establish div {
  display: inline-block;
}

.com-establish div img {
  max-width: 25px;
  max-height: 25px;
  margin: 0 2px;
}

.Hired {
  background: #00bf8f;
}

.Cancelled, Rejected {
  background: #DC143C;
}

@media screen and (min-width: 992px) and (max-width: 1200px) {
  .nav-padd-20 {
    padding-left: 90px;
  }
}

@media screen and (max-width: 992px) {
  .img1 img {
    width: 180px;
    height: 125px;
    object-fit: cover;
  }

  .nav-padd-20 {
    padding-left: 120px;
    padding-bottom: 20px;
  }

  .follow-btn, .social-btns {
    text-align: right
  }
}

@media screen and (max-width: 768px) {
  .img1 img {
    width: 100%;
    height: 100%;
  }

  .logo-box {
    margin: 0 auto;
  }

  .padd-top-0 {
    padding-top: 0px !important;
    margin-top: -20px !important;
  }

  .h-inner {
    display: block;
    min-height: 500px;
    text-align: center;
  }

  .com-names {
    font-size: 32px;
  }

  .com-establish {
    font-size: 14px;
  }

  .follow-btn, .social-btns {
    text-align: center;
  }

  .logo-absolute {
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .nav-padd-20 {
    text-align: center;
    padding-left: 0px;
  }

  .team-text {
    top: 152px;
    left: auto;
    right: 10px;
    -webkit-transform: none;
    -ms-transform: none;
    transform: none;
  }

  .know-bet {
    display: none;
  }

  .team-container .team-overlay {
    height: 100%;
    background-color: transparent;
  }

}

.cover-bg-color {
  height: 100%;
  width: 100%;
  position: absolute;
  background-color: #00000057;
}
</style>

<script>
import axios from 'axios'
import toastr from "../../public/js/toastr";
import {requestHeaders} from "../_helpers/apiHelper";

export default {
  data() {
    return {
      organization_enc_id: "",
      name: "",
      logo: "",
      cover_image: "",
      number_of_employees: "",
      tag_line: "",
      industry: "",
      vision: "",
      establishment_year: "",
      description: "",
      mission: "",
      opportunties_count: "",
      facebook: "",
      twitter: "",
      linkedin: "",
      website: "",
      benefit: [],
      gallery: [],
      team: [],
      userType: this.$store.getters.getUserType,
      opportuntiesJobs: [],
      opportuntiesInternships: [],
      appliedCandidates: [],
      appliedCandidatesCount: '',
      followed: false,
      average_rating: "",
      reviews_cnt: "",
      labelsData: "",
    }
  },
  mounted() {
    if (this.$route.query.slug) {
      var t = this
      var slug = this.$route.query.slug;
      var url = this.$store.getters.getDomain;

      axios({
        method: 'POST',
        url: `${url}api/v2/organizations/detail`,
        data: {slug: slug},
        headers: {
          'Authorization': "Bearer " + localStorage.getItem('token'),
          'source': localStorage.getItem('source'),
          'Content-Type': 'application/json'
        }
      })
          .then(function (response) {
            document.getElementById("h-page-load").classList.add("hides");
            t.organization_enc_id = response['data']['response']['organization']['organization_enc_id'];
            t.name = response['data']['response']['organization']['name'];
            t.labelsData = response['data']['response']['labels'];
            t.logo = response['data']['response']['organization']['logo'];
            if (response['data']['response']['organization']['cover_image']) {
              t.cover_image = response['data']['response']['organization']['cover_image'];
            } else {
              t.cover_image = 'https://empoweryouth.com/assets/themes/ey/images/backgrounds/default_cover.png'
            }
            t.number_of_employees = response['data']['response']['organization']['number_of_employees'];
            t.industry = response['data']['response']['industry'];
            t.tag_line = response['data']['response']['organization']['tag_line'];
            t.vision = response['data']['response']['organization']['vision'];
            t.establishment_year = response['data']['response']['organization']['establishment_year'];
            t.description = response['data']['response']['organization']['description'];
            t.mission = response['data']['response']['organization']['mission'];
            t.opportunties_count = response['data']['response']['opportunties_count'];
            t.facebook = response['data']['response']['organization']['facebook'];
            t.twitter = response['data']['response']['organization']['twitter'];
            t.linkedin = response['data']['response']['organization']['linkedin'];
            t.website = response['data']['response']['organization']['website'];
            t.average_rating = parseInt(response['data']['response']['reviews']['average_rating']);
            t.reviews_cnt = response['data']['response']['reviews']['reviews_cnt'];
            for (var i = 0; i < response['data']['response']['benefit'].length; i++) {
              t.benefit.push(response['data']['response']['benefit'][i])
            }
            for (var j = 0; j < response['data']['response']['gallery'].length; j++) {
              t.gallery.push(response['data']['response']['gallery'][j])
            }
            for (var k = 0; k < response['data']['response']['team'].length; k++) {
              t.team.push(response['data']['response']['team'][k])
            }
          })
          .catch(function (error) {
            // console.log(error)
          })
      this.getOpportunities();
      this.getAppliedCandidates();
    } else {
          this.$router.push('/dashboard');
      }
  },
  methods: {
    follow: function (event) {
      var element = event.currentTarget
      var data_key = element.getAttribute('data-key');
      var url = this.$store.getters.getDomain;
      // var slug = this.$route.query.slug;
      axios.post(`${url}api/v2/organizations/follow`, {id: data_key}, {
        headers: requestHeaders()
      })
      if (!this.followed) {
        this.followed = true;
        return false;
      } else {
        this.followed = false;
      }
    },
    getOpportunities: function (event) {
      var t = this;
      var slug = this.$route.query.slug;
      var url = this.$store.getters.getDomain;

      axios({
        method: 'POST',
        url: `${url}api/v2/organizations/opportunities`,
        data: {slug: slug},
        headers: {
          'Authorization': "Bearer " + localStorage.getItem('token'),
          'source': localStorage.getItem('source'),
          'Content-Type': 'application/json'
        }
      })
          .then(function (response) {
            t.opportuntiesJobs = [];
            t.opportuntiesInternships = [];
            if (response['data']['response']['jobs'].length) {
              t.opportuntiesJobs = response['data']['response']['jobs'];
            }
            if (response['data']['response']['internships'].length) {
              t.opportuntiesInternships = response['data']['response']['internships'];
            }
          })
          .catch(function (error) {
            // console.log(error)
          })
    },
    getAppliedCandidates: function (event) {
      var t = this;
      var slug = this.$route.query.slug;
      var url = this.$store.getters.getDomain;

      axios({
        method: 'POST',
        url: `${url}api/v2/organizations/applied-users`,
        data: {slug: slug},
        headers: {
          'Authorization': "Bearer " + localStorage.getItem('token'),
          'source': localStorage.getItem('source'),
          'Content-Type': 'application/json'
        }
      })
          .then(function (response) {
            if (response['data']['response']['data'].length) {
              t.appliedCandidatesCount = response['data']['response']['count'];
              t.appliedCandidates = response['data']['response']['data'];
            }
          })
          .catch(function (error) {
            // console.log(error)
          })
    },
    changeAppStatus: function (event, status) {
      var t = this;
      var element = event.currentTarget;
      var data_key = element.getAttribute('data-key');
      var data_id = element.getAttribute('data-id');
      element.parentElement.parentElement.parentElement.classList.remove('p-0');
      element.parentElement.parentElement.parentElement.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
      var url = this.$store.getters.getDomain;
      axios.post(`${url}api/v2/college-index/job-approve`, {
        application_enc_id: data_key,
        org_enc_id: data_id,
        action: status
      }, {
        headers: requestHeaders()
      }).then(function (response) {
        if (response['data']['response']['status'] == 200) {
          toastr.success('Application ' + status + 'ed Successfully', 'Success');
        } else {
          toastr.error('Something went wrong. Please try again.', 'Oops!!');
        }
        t.getOpportunities();
      })
    },
  }
}
</script>
